import React from 'react'
import { Panel, Row, Col } from 'rsuite'

export default function ProjectBasicInfoUnshaded({ schema }) {
  return (
    <>
      <Panel header={schema.projectBasicInfoHeader} bordered collapsible defaultExpanded>
        <div>
          <Row style={{ marginTop: 10 }}>
            {schema.projectNameTitle && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <span>
                  {schema.projectNameTitle} :{' '}
                  <b>{schema.projectName ? schema.projectName : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {schema.projectCodeTitle && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <span>
                  {schema.projectCodeTitle} :{' '}
                  <b>{schema.projectCode ? schema.projectCode : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {schema.projectTypeTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.projectTypeTitle} :{' '}
                  <b>{schema.projectType ? schema.projectType : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {schema.projectProposalTypeTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.projectProposalTypeTitle} :{' '}
                  <b>{schema.projectProposalType ? schema.projectProposalType : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {schema.statusTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.statusTitle} : <b>{schema.status ? schema.status : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {schema.projectProposalStyleTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.projectProposalStyleTitle} :{' '}
                  <b>{schema.projectProposalStyle ? schema.projectProposalStyle : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {schema.ownerNameTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.ownerNameTitle} :{' '}
                  <b>{schema.ownerName ? schema.ownerName : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
            {schema.activityTypeTitle && (
              <Col xs={24} sm={24} md={12} lg={12}>
                <span>
                  {schema.activityTypeTitle}
                  <span style={{ color: 'red' }}>{` ${schema.activityTypeTitle2}`}</span>
                  {' : '}
                  <b>{schema.activityType ? schema.activityType : ' -ไม่ระบุ-'}</b>
                </span>
              </Col>
            )}
          </Row>
        </div>
      </Panel>
    </>
  )
}
